<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">
									{{ o.SchoolName }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Infraction</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="InfractionID" [(ngModel)]="report.InfractionID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of infractionList" [ngValue]="o.InfractionID">
									{{ o.InfractionDesc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Action</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PenaltyID" [(ngModel)]="report.PenaltyID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of actionList" [ngValue]="o.PenaltyID">
									{{ o.PenaltyDesc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-4 col-lg-2 control-label">Criteria</label>
						<div class="col-sm-8 col-lg-3">
							<div class="input-group">
								<input type="text" name="SearchValue" [(ngModel)]="report.Criteria" class="form-control" />
								<span class="input-group-btn">
									<button type="button" class="btn btn-primary">Search</button>
								</span>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>

<!--<form class="form-horizontal">

                            
    <table class="table table-striped table-bordered table-hover" my-table options="options" width="100%" id="myStudentAlertListTable">
        <thead>
            <tr>
                        
                <th>StudentName</th>
               
               
                <th>Infraction</th>
                <th>Action</th>

                  <th></th>   

            </tr>
        </thead>
        <tbody></tbody>

    </table>
</form> -->
